module.exports = __webpack_public_path__ + "img/Weapon_130.983b7329.png";